<template>
  <div class="no-content">
    <img src="@/static/store-locator/faq-empty-state.svg" />
    <h2 class="no-content__title">
      {{ $t("message.storeLocator.faq.addFaqToFacilities") }}
    </h2>
    <div v-if="$slots.default" class="empty-state__actions">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorFaqEmptyState"
};
</script>

<style lang="scss" scoped>
.no-content {
  border-radius: 25px;
  background: $gray-750;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: $spacing * 3;
  gap: $spacing * 3;

  &__title {
    @include font-size(22px);
    font-weight: 600;
  }

  &__actions {
    display: flex;
    justify-content: center;
  }
}
</style>
